// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const cs: KnowledgePagesCopy = {
  knowledgePage: 'Stránka znalostí',
  knowledgePages: 'Stránky znalostí',
  featureOffTitle: 'Stránky znalostí nejsou v tomto pracovním prostoru zapnuté.',
  featureOffBody: 'Kontext a zdroje společnosti jsou dál v sekci Znalosti.',
  loadingPage: 'Načítání stránky…',
  loadingSuggestion: 'Načítání návrhu…',
  cancel: 'Zrušit',
  tryAgain: 'Zkusit znovu',
  everyoneIn: 'Všichni ve společnosti {company}',
  yourCompany: 'vaší společnosti',
  revision: 'Revize {n}',
  openRevision: 'Otevřít revizi {n}',
  pageCount: 'one:stránka|few:stránky|many:stránky|other:stránek',
  topicCount: 'one:téma|few:témata|many:tématu|other:témat',
  sectionCount: 'one:oddíl|few:oddíly|many:oddílu|other:oddílů',
  lineCount: 'one:řádek|few:řádky|many:řádku|other:řádků',
  documentCount: 'one:dokument|few:dokumenty|many:dokumentu|other:dokumentů',
  changeCount: 'one:změna|few:změny|many:změny|other:změn',
  newPageCount: 'one:nová stránka|few:nové stránky|many:nové stránky|other:nových stránek',
  changedPageCount:
    'one:změněná stránka|few:změněné stránky|many:změněné stránky|other:změněných stránek',
  otherSectionCount: 'one:další oddíl|few:další oddíly|many:dalšího oddílu|other:dalších oddílů',
  characterCount: 'one:znak|few:znaky|many:znaku|other:znaků',
  diffStats: 'Změněno: {sections} · přidáno: {added} · odebráno: {removed}',
  diffMatchesBase: 'Navrhovaný text odpovídá výchozí revizi.',
  diffIntroduction: 'Úvod',
  diffOtherUnchanged: 'Beze změny: {sections}.',
  timeJustNow: 'právě teď',
  originImportedFrom: 'Importováno z {path}',
  originImportedFromCommit: 'Importováno z {path} @ {commit}',
  authorityApprovedInPoneva: 'Schváleno v Poneva',
  authorityImported: 'Importováno',
  authorityInRepository: '{canonicality} v repozitáři',
  authorityVerified: 'ověřeno {date}',
  authorRepositoryImport: 'Import z repozitáře',
  authorSuggestedInChat: 'Navrženo v chatu',
  authorSuggestedInChatWith: 'Navrženo v chatu s {name}',
  authorSuggestedBy: 'Navrhl(a) {name}',
  authorSuggestedByApp: 'Navrženo připojenou aplikací',
  authorSuggestedByColleague: 'Navrženo kolegou',
  authorSuggestedByYou: 'Navrženo vámi',
  authorSuggestedOnBehalf: 'Navrhl {app} jménem {name}',
  authorSuggestedByAppOnBehalf: 'Navrženo připojenou aplikací jménem {name}',
  authorSuggestedAndApproved: 'Navrhl(a) a schválil(a) {name}',
  approverApprovedBy: 'schválil(a) {name}',
  approverAppliedBy: 'použil(a) {name}',
  kindCreatePage: 'Nová stránka',
  kindUpdatePage: 'Navrhovaná úprava',
  kindArchivePage: 'Archivace',
  statusConflict: 'Konflikt · stránka se změnila',
  statusPending: 'Čeká na kontrolu',
  statusApproved: 'Schváleno',
  statusRejected: 'Odmítnuto',
  statusWithdrawn: 'Staženo',
  statusSuperseded: 'Nahrazeno',
  errRevisionConflict: 'Tato stránka se změnila, zatímco jste ji kontrolovali.',
  errProposalChanged:
    'Tento návrh se změnil, zatímco jste ho kontrolovali. Než se rozhodnete, zkontrolujte nejnovější verzi.',
  errPublishRequired:
    'Změny znalostí může schvalovat a stránky importovat jen osoba s právem publikovat ve společnosti.',
  errProposalLimit:
    'Ve vaší společnosti už na kontrolu čeká 200 návrhů. Než navrhnete další, některé zkontrolujte.',
  errAuthorLimit:
    'Na kontrolu už čeká 50 vašich návrhů. Než navrhnete další, počkejte, až se o některých rozhodne, nebo některé stáhněte.',
  errImportProposalLimit:
    'Tento import by přidal ke kontrole více změněných stránek, než se vejde do fronty kontroly vaší společnosti (nejvýše 200). Rozhodněte o některých návrzích v sekci Ke kontrole a pak import použijte znovu.',
  errImportChanged:
    'Toto není import, který jste zkontrolovali. Otevřete ho znovu a před použitím ho zkontrolujte.',
  errImportItemNotFound: 'Tento dokument už není součástí importu.',
  errIdempotencyConflict:
    'Tento návrh už byl odeslán s jiným obsahem. Načtěte stránku znovu a zkuste to znovu.',
  errImportHashMismatch:
    'Soubor v tomto snímku neodpovídá zaznamenanému kontrolnímu součtu. Vytvořte nový snímek a zkuste to znovu.',
  errImportAlreadyApplied: 'Tento import už byl použit.',
  errImportDiscarded: 'Tento import byl zahozen. Vyberte soubor snímku znovu.',
  errImportDuplicateItem: 'Tento snímek obsahuje stejný dokument dvakrát. Vytvořte snímek znovu.',
  errInvalidImport:
    'Poneva tento snímek nemohla přijmout. Vytvořte nový skriptem pro snímky a zkuste to znovu.',
  errInvalidInput: 'Poneva tento vstup nemohla přijmout. Zkontrolujte pole a zkuste to znovu.',
  errImportLimit:
    'Příliš mnoho importů je připraveno, ale nepoužito. Než připravíte další, některé použijte nebo zahoďte.',
  errPageTooLarge: 'Stránka je větší než 256 KB. Rozdělte ji na menší stránky.',
  errTooManySections: 'Stránka má více než 2 000 nadpisů. Rozdělte ji na menší stránky.',
  errPageLimit: 'Vaše společnost dosáhla limitu 2 000 stránek znalostí.',
  errCollectionLimit: 'Vaše společnost dosáhla limitu 100 témat.',
  errProposalNotPending: 'O tomto návrhu už bylo rozhodnuto. Zobrazený stav je aktuální.',
  errRequesterRemoved:
    'Osoba, která tento návrh podala, už v této společnosti není, takže ho nelze schválit.',
  errRevisionAlreadyCurrent: 'Tato revize už je aktuální.',
  errPageArchived:
    'Tato stránka byla archivována, zatímco jste ji kontrolovali. Než se rozhodnete, zkontrolujte návrh znovu.',
  errAlreadyArchived: 'Tato stránka už je archivovaná.',
  errProposalForbidden: 'Stáhnout ho může jen osoba, která tento návrh podala.',
  errUnavailable: 'Stránky znalostí teď nejsou k dispozici.',
  errTimeout: 'Poneva odpovídala příliš dlouho.',
  errItemTooLarge: '{path} je větší než 256 KB. Rozdělte ho na menší stránky.',
  errItemTooManySections: '{path} má více než 2 000 nadpisů. Rozdělte ho na menší stránky.',
  errItemHashMismatch:
    '{path} neodpovídá zaznamenanému kontrolnímu součtu. Vytvořte nový snímek a zkuste to znovu.',
  errNoLongerAvailable: 'Tato položka už pro vás není dostupná.',
  errTooLargeToSend: 'Tento soubor je příliš velký na odeslání.',
  cardChecking: 'Kontroluje se stav…',
  cardNotAvailable: 'Nedostupné',
  cardStatusUnavailable: 'Stav není k dispozici',
  cardUnshowable: 'Tuto navrhovanou úpravu znalostí nelze zobrazit.',
  cardEyebrow: 'Navrhovaná úprava znalostí',
  cardLabel: 'Navrhovaná úprava znalostí · {title}',
  cardMissing: 'Tento návrh už pro vás není dostupný.',
  cardUnknown:
    'Nepodařilo se ověřit, v jakém stavu tento návrh je. Jeho stav uvidíte po otevření kontroly.',
  cardCheckAgain: 'Zkontrolovat znovu',
  cardReview: 'Zkontrolovat úpravu',
  statusLineApproved: 'Schválené porozumění',
  readyCount:
    'one:připraven k vyhledávání|few:připraveny k vyhledávání|many:připraveno k vyhledávání|other:připraveno k vyhledávání',
  preparingCount: 'one:se připravuje|few:se připravují|many:se připravuje|other:se připravuje',
  attentionCount:
    'one:vyžaduje pozornost|few:vyžadují pozornost|many:vyžaduje pozornost|other:vyžaduje pozornost',
  topicsExplore: 'Prozkoumat téma',
  topicsAllPages: 'Všechny stránky',
  topicsOpenPages: 'Otevřít Stránky',
  topicsEmpty:
    'Zatím nejsou žádné schválené stránky. Stránky obsahují podrobné porozumění společnosti s úplnou historií revizí.',
  reviewsTitle: 'Navrhované úpravy stránek',
  reviewsTitleMine: 'Vaše navrhované úpravy stránek',
  reviewsIntro:
    'Každý návrh je úplná kandidátní revize s odůvodněním a podklady. Nic se nezmění, dokud neschválíte přesně tuto revizi.',
  reviewsIntroMine:
    'Vaše návrhy tu čekají, dokud je nezkontroluje osoba s právem publikovat ve společnosti. Do té doby zůstávají stránky beze změny.',
  loadPagesFailed: 'Stránky znalostí se nepodařilo načíst.',
  loadProposalsFailed: 'Navrhované úpravy stránek se nepodařilo načíst.',
  loadMoreFailed: 'Další stránky se nepodařilo načíst.',
  otherPages: 'Ostatní stránky',
  loadTopicFailed: 'Toto téma se nepodařilo načíst.',
  revisionShort: 'r{n}',
  updatedOn: 'Aktualizováno {date}',
  emptyTitle: 'Zatím žádné stránky znalostí.',
  emptyBody:
    'Stránky obsahují schválené podrobné porozumění vaší společnosti — směřování, rozhodnutí a způsoby práce — a uchovávají každou revizi. Importujte je ze snímku repozitáře nebo začněte stránku v chatu; každou stránku musí schválit publikující, než se stane znalostí společnosti.',
  importFromSnapshot: 'Importovat ze snímku repozitáře',
  startInChat: 'Začít stránku v chatu',
  startInChatPrompt:
    'Pomoz mi založit stránku znalostí pro naši společnost. Zeptej se, co má pokrývat, a nevymýšlej obsah. Zůstane návrhem, dokud ji neschválí osoba s právem publikovat ve společnosti.',
  loadingPages: 'Načítání stránek znalostí…',
  filterLabel: 'Filtrovat stránky podle názvu',
  filterPlaceholder: 'Filtrovat stránky',
  importButton: 'Importovat',
  showingTopic: 'Zobrazeno: {topic}',
  showAllTopics: 'Zobrazit všechna témata',
  loadingTopic: 'Načítání tématu…',
  noMatch: 'Výrazu „{filter}“ neodpovídají žádné stránky.',
  topicNoPages: 'V tomto tématu zatím nejsou žádné schválené stránky.',
  loading: 'Načítání…',
  loadMore: 'Načíst další stránky',
  metaApproved: 'schváleno {date}',
  metaRepositoryAuthoritative: 'rozhodující zůstává repozitář',
  loadPageFailed: 'Tuto stránku se nepodařilo načíst.',
  loadHistoryFailed: 'Historii revizí se nepodařilo načíst.',
  outlineLabel: 'Oddíly stránky',
  outlineToggle: 'Na této stránce',
  loadingHistory: 'Načítání historie revizí…',
  historyLabel: 'Historie revizí',
  historyIntro:
    'Každá schválená revize se uchovává. Obnovení starší revize vytvoří návrh ke kontrole; pozdější revize nikdy nesmaže.',
  historyCurrent: 'Aktuální',
  historyViewing: 'Zobrazeno',
  historyView: 'Zobrazit',
  historyViewAria: 'Zobrazit revizi {n}',
  restoreAria: 'Obnovit jako návrh: revize {n}',
  restoreCreating: 'Vytváří se návrh…',
  restore: 'Obnovit jako návrh',
  restoreUnconfirmed:
    'Nepodařilo se ověřit, že byl návrh vytvořen. Než to zkusíte znovu, podívejte se do sekce Ke kontrole.',
  editTooLarge: 'Tato stránka je větší než 256 KB. Než ji navrhnete, rozdělte ji na menší stránky.',
  editConflict:
    'Tato stránka se během vašich úprav změnila. Zkopírujte si text, otevřete nejnovější revizi a navrhněte úpravu znovu.',
  editUnconfirmed:
    'Nepodařilo se ověřit, že byl váš návrh odeslán. Než ho odešlete znovu, podívejte se do sekce Ke kontrole.',
  editHeading: 'Navrhnout úpravu',
  editIntro:
    'Upravujete revizi {n}. Osoba s právem publikovat ve společnosti zkontroluje přesnou změnu, než se z ní stane revize {next}; do té doby zůstává stránka beze změny.',
  editOutdated:
    'Během vašich úprav byla schválena novější revize. Zkopírujte si text a začněte znovu od nejnovější revize, aby se nic z jejích změn neztratilo.',
  editContentLabel: 'Obsah stránky (Markdown)',
  editReasonLabel: 'Proč tato změna?',
  editReasonPlaceholder: 'Co se změnilo a odkud to pochází.',
  editSending: 'Odesílání…',
  editSend: 'Odeslat ke kontrole',
  editDiscardConfirm: 'Zahodit tuto úpravu? Nic z toho, co jste změnili, nebylo odesláno.',
  editNoChanges: 'Zatím žádné změny.',
  editNeedsContent: 'Stránka musí mít nějaký obsah.',
  exportFailed: 'Tuto stránku se nepodařilo exportovat. Zkuste to znovu.',
  askPagePrompt: 'Otázka ke stránce znalostí „{title}“ (revize {n}, {link}):',
  askPageSectionPrompt: 'Otázka ke stránce znalostí „{title}“ § {section} (revize {n}, {link}):',
  pageMissingTitle: 'Tato stránka není dostupná.',
  pageMissingBody: 'Možná byla archivována, nebo už nemáte přístup ke znalostem této společnosti.',
  pageArchived: 'Archivováno',
  viewingRevisionCurrent: 'Prohlížíte revizi {n}; aktuální revize je {current}.',
  viewingRevisionOld: 'Prohlížíte revizi {n}. Není to aktuální revize.',
  openCurrent: 'Otevřít aktuální',
  archivedBanner:
    'Tato stránka je archivovaná. Už neovlivňuje odpovědi; její historie se uchovává.',
  pageViewsLabel: 'Zobrazení stránky',
  tabRead: 'Číst',
  tabHistory: 'Historie',
  unknownSection: 'Odkazovaný oddíl není součástí této revize. Zobrazuje se celá stránka.',
  askAboutPage: 'Zeptat se na tuto stránku',
  exporting: 'Exportování…',
  exportMarkdown: 'Exportovat Markdown',
  loadSuggestionFailed: 'Tento návrh se nepodařilo načíst.',
  evidenceSource: 'Zdroj',
  evidenceFact: 'Kontext společnosti',
  evidenceResult: 'Uložená práce',
  evidenceUrl: 'Webová stránka',
  evidenceDecision: 'Rozhodnutí',
  evidenceReference: 'Odkaz',
  evidenceOpenPage: 'Otevřít stránku znalostí',
  evidenceOpenSource: 'Otevřít zdroj',
  evidenceOpenFact: 'Otevřít kontext společnosti',
  evidenceOpenResult: 'Otevřít uloženou práci',
  evidenceOpenUrl: 'Otevřít webovou stránku',
  evidenceOpenDecision: 'Otevřít rozhodnutí',
  evidenceOpenReference: 'Otevřít odkaz',
  evidenceDecisionNote: 'Zaznamenané rozhodnutí. V Poneva není co otevřít.',
  evidenceFactGone: 'Tento kontext společnosti už není uložený.',
  evidencePageNoRevision: 'Tato stránka nemá žádnou schválenou revizi, kterou by šlo otevřít.',
  evidencePrivateExcerpt: 'Soukromý podklad — sdílen byl jen výňatek výše.',
  evidencePrivate: 'Soukromý podklad — jeho obsah s vámi nebyl sdílen.',
  evidenceHeading: 'Podklady',
  evidenceNone: 'Nebyly připojeny žádné podklady. Posuďte odůvodnění výše samostatně.',
  changeAdded: 'Přidáno',
  changeRemoved: 'Odebráno',
  changeChanged: 'Změněno',
  changeUnchanged: 'Beze změny',
  moreLineCount: 'one:další řádek|few:další řádky|many:dalšího řádku|other:dalších řádků',
  moreUnchangedLineCount:
    'one:další nezměněný řádek|few:další nezměněné řádky|many:dalšího nezměněného řádku|other:dalších nezměněných řádků',
  unchangedLineCount:
    'one:nezměněný řádek|few:nezměněné řádky|many:nezměněného řádku|other:nezměněných řádků',
  skipAdded: '{lines} — zobrazeno v úplné revizi',
  skipRemoved: 'Odebráno: {lines}',
  cutUnchanged: 'Nezobrazeno: {lines}',
  cutChanged: 'Nezobrazeno: {lines}, {changes}. Zkontrolujte je v úplné revizi.',
  cutAddedRemoved: 'přidáno {added} a odebráno {removed}',
  cutAdded: 'přidáno {added}',
  cutRemoved: 'odebráno {removed}',
  lineAddedSr: 'Přidáno:',
  lineRemovedSr: 'Odebráno:',
  noLinesAdded: 'Nový oddíl. Jeho text je v úplné revizi níže.',
  noLinesRemoved: 'Tento oddíl by byl ze stránky odebrán.',
  noLinesChanged: 'Tento oddíl se mění. Jeho text je v úplné revizi níže.',
  diffHeading: 'Změny',
  outcomeArchived: 'Archivováno.',
  outcomeArchivedBody:
    'Stránka „{title}“ už neovlivňuje odpovědi a zmizela ze seznamu stránek. Její revize, tento návrh a rozhodnutí zůstávají v historii stránky.',
  openArchivedPage: 'Otevřít archivovanou stránku',
  outcomeApproved: 'Schváleno.',
  outcomeApprovedRevision: 'Revize {n} je teď schválenou verzí stránky „{title}“.',
  outcomeApprovedPlain: 'Tento návrh byl schválen.',
  outcomeRestored: 'Stránka je zpět v seznamu stránek a znovu ovlivňuje odpovědi.',
  outcomeKept: 'Návrh, rozhodnutí i všechny starší revize zůstávají v historii stránky.',
  openPage: 'Otevřít stránku',
  outcomeDismissed: 'Odmítnuto.',
  outcomeWithdrawn: 'Staženo.',
  outcomeSuperseded: 'Nahrazeno.',
  outcomeSupersededBody:
    'Novější revize, návrh nebo import z repozitáře učinily tento návrh zastaralým. Sám o sobě nic nezměnil.',
  outcomeUnchanged: 'Stránka zůstává beze změny.',
  approveNewPage: 'Schválit novou stránku',
  approveArchive: 'Schválit archivaci',
  approveRestoreRevision: 'Obnovit a schválit revizi {n}',
  approveRevision: 'Schválit revizi {n}',
  approveArchiveNote: 'Schválením se tato stránka archivuje pro všechny v rámci {company}.',
  approvePublishNote: 'Schválením se tato revize zveřejní pro všechny v rámci {company}.',
  approvePublishEvidenceNote:
    'Schválením se tato revize i výňatky z podkladů zobrazené výše zveřejní pro všechny v rámci {company}.',
  archivedTitle: 'Tato stránka je archivovaná.',
  alreadyArchivedBody: 'Schválení by nic nezměnilo, takže tento návrh lze jen odmítnout.',
  archivedRestoreBody:
    'Schválením se stránka obnoví: vrátí se s touto revizí do seznamu stránek, vyhledávání i odpovědí.',
  staleRevisionAction: 'Porovnat s nejnovější verzí',
  staleProposalTitle: 'Tento návrh se změnil, zatímco jste ho kontrolovali.',
  staleProposalAction: 'Zkontrolovat nejnovější verzi',
  staleArchivedTitle:
    'Tato stránka byla archivována, zatímco jste ji kontrolovali. Schválením tohoto návrhu by se vrátila zpět.',
  staleArchivedAction: 'Zkontrolovat znovu',
  suggestionMissingTitle: 'Tento návrh není dostupný.',
  suggestionMissingBody:
    'Možná byl stažen, nebo patří někomu jinému a nebyl odeslán ke kontrole ve společnosti.',
  decideUnconfirmed:
    'Vaše rozhodnutí se nepodařilo ověřit. Zobrazený stav je nejnovější z Poneva; než to zkusíte znovu, zkontrolujte ho.',
  decideFailed: 'Vaše rozhodnutí se nepodařilo uložit.',
  discussPrompt: 'Pomoz mi vyladit navrhovanou úpravu znalostí na stránce „{title}“ ({link}).',
  conflictBody:
    'Tento návrh vychází z revize {base}; aktuální revize je {current}. Jeho schválení by tuto změnu přepsalo, proto ho v této podobě nelze schválit.',
  conflictBodyPlain: 'Tento návrh vychází ze starší revize, proto ho v této podobě nelze schválit.',
  openLatest: 'Otevřít nejnovější verzi',
  reworkInChat: 'Přepracovat v chatu',
  factReason: 'Odůvodnění',
  factNoReason: 'Nebylo uvedeno žádné odůvodnění.',
  factAudience: 'Publikum',
  factRevision: 'Revize',
  revisionNew: 'Nová stránka, revize 1',
  revisionArchiveAfter: 'Archivace po revizi {n}',
  revisionWrittenAgainst: 'Vychází z revize {base}; aktuální revize je {current}',
  revisionCurrentToProposed: 'Aktuální revize {base} → navrhovaná revize {next}',
  revisionProposed: 'Navrhovaná revize {next}',
  proposedPage: 'Navrhovaná stránka',
  archivingHeading: 'Co archivace dělá',
  archivingBody:
    'Stránka přestane ovlivňovat odpovědi a zmizí ze seznamu stránek. Její revize i toto rozhodnutí se uchovají.',
  noComparison: 'Pro tento návrh není porovnání oddílů k dispozici.',
  showComplete: 'Zobrazit úplnou revizi',
  approving: 'Schvalování…',
  dismissing: 'Odmítání…',
  dismiss: 'Odmítnout',
  withdrawing: 'Stahování…',
  withdraw: 'Stáhnout',
  editInChat: 'Upravit v chatu',
  waitingForPublisher: 'Čeká na kontrolu, kterou provede osoba s právem publikovat ve společnosti.',
  snapshotTooLarge: 'Tento snímek je větší než 8 MB. Vytvořte ho s menším počtem dokumentů.',
  snapshotNotSnapshot:
    'Tento soubor není snímek znalostí. Vyberte soubor JSON, který vytvořil skript pro snímky.',
  snapshotEmpty: 'Tento snímek neobsahuje žádné dokumenty.',
  readDocumentFailed: 'Tento dokument se nepodařilo přečíst. Zkuste to znovu.',
  readingDocument: 'Čtení dokumentu…',
  hideText: 'Skrýt text',
  readText: 'Číst text',
  textOf: 'Text: {title}',
  gitSnapshot: 'Snímek Git {commit}',
  repositorySnapshot: 'Snímek repozitáře',
  importNewHeading: '{pages} · schválení při použití',
  importNewNote:
    'Každá se zveřejní jako schválená stránka pro všechny v rámci {company}, bez další kontroly. Před použitím si každou přečtěte.',
  importChangedHeading: '{pages} · odeslání ke kontrole',
  importChangedNote:
    'Z každé se stane navrhovaná úprava. Její stránka se změní, až když ji publikující schválí v sekci Ke kontrole, kde je vidět, co se změnilo.',
  unchangedDocumentCount:
    'one:nezměněný dokument|few:nezměněné dokumenty|many:nezměněného dokumentu|other:nezměněných dokumentů',
  unchangedNote: 'Tyto dokumenty už odpovídají svým schváleným stránkám. Nic se pro ně nezapisuje.',
  stagedHeading: 'Připraveno, ale nepoužito',
  excludedSummary: 'Vynecháno z tohoto snímku: {documents}',
  countsLine: '{newPages} · ke kontrole: {changedPages} · beze změny: {unchanged}',
  importAlreadyDiscarded: 'Tento import už byl zahozen.',
  confirmLabel: 'Potvrdit import',
  unchangedKeepCount:
    'one:nezměněný dokument si ponechá svou stránku|few:nezměněné dokumenty si ponechají své stránky|many:nezměněného dokumentu si ponechá své stránky|other:nezměněných dokumentů si ponechá své stránky',
  confirmBody:
    'Použít tento import pro všechny v rámci {company}? {newPages}: schválení jako revize 1; {changedPages}: čekání na kontrolu; {unchanged}. Dřívější návrhy z importu pro tyto stránky budou staženy.',
  applying: 'Používání…',
  applyImport: 'Použít import',
  chooseAnother: 'Vybrat jiný soubor',
  allCurrent: 'Vše v tomto snímku už je aktuální.',
  importApplied: 'Import byl použit.',
  appliedSummary: 'Vytvořeno: {pages} · čeká na kontrolu: {changes} · beze změny: {unchanged}.',
  appliedIndexing:
    'Nové stránky budou v chatu vyhledatelné po dokončení indexování. Průběh ukazuje příprava zdrojů.',
  openPages: 'Otevřít stránky',
  reviewChanges: 'Zkontrolovat: {changes}',
  checkIndexing: 'Zkontrolovat průběh indexování',
  sendSnapshotFailed: 'Tento snímek se nepodařilo odeslat. Zkuste to znovu.',
  openStagedFailed: 'Tento připravený import se nepodařilo otevřít.',
  applyUnconfirmed:
    'Nepodařilo se ověřit, zda byl import použit. Než to zkusíte znovu, podívejte se do sekce Stránky.',
  applyFailed: 'Tento import se nepodařilo použít.',
  importHeading: 'Importovat stránky z repozitáře',
  backToPages: 'Zpět na stránky',
  importLead:
    'Vytvořte snímek pomocí {command} a pak vyberte soubor. Než se cokoli uloží, uvidíte každý dokument a co by změnil.',
  snapshotFileLabel: 'Soubor snímku znalostí',
  readingSnapshot: 'Čtení snímku…',
  openingStaged: 'Otevírání připraveného importu…',
  chooseSnapshot: 'Vybrat soubor snímku',
  factOrigin: 'Původ',
  factContents: 'Obsah',
  importOnlyListed: 'Importují se jen dokumenty uvedené zde.',
  importRepositoryAuthoritative:
    'Rozhodující zůstává repozitář; ze změněných dokumentů se stanou návrhy ke kontrole.',
  overviewReviewChanges: 'Zkontrolovat změny',
  overviewConnectAgents: 'Připojit externí agenty',
  overviewEyebrow: 'Společné porozumění',
  overviewTitle: '{company} v kontextu.',
  overviewLeadFallback:
    'Znalosti vaší společnosti začínají kontextem, který sdílíte. Budujte porozumění svému podnikání společně.',
  overviewBody:
    'Kontext společnosti a zdrojové materiály dávají Poneva výchozí bod — ne vše, co se dá o {company} vědět. Rozvíjejte toto porozumění spolu s tím, jak se vaše podnikání vyvíjí.',
  overviewAskPrompt: 'Co víš o naší společnosti a co by bylo užitečné doplnit?',
  overviewAsk: 'Zeptat se na {company}',
  overviewAddSources: 'Přidat zdroje',
  contextEyebrow: 'Co dává odpovědím kontext',
  contextTitle: 'Podnikání za otázkou.',
  contextBody:
    'Zdroje z webu vysvětlují veřejnou stránku podnikání. Poznámky společnosti přidávají vaši terminologii, priority a způsob práce.',
  contextPrompt:
    'Pomoz mi ujasnit priority společnosti a pracovní preference, které si máme pamatovat.',
  contextAction: 'Budovat naše porozumění',
  learnEyebrow: 'Prostor k učení',
  learnTitle: 'Začněte tím, na čem záleží teď.',
  learnBody:
    'Přineste zdrojové materiály nebo upřesněte, jak vaše společnost funguje. Poneva může navrhovat trvalé změny, které zkontrolujete.',
  learnPrompt:
    'Jaké důležité informace nám na základě stávajících znalostí společnosti chybí pro práci, kterou chceme dělat?',
  learnAction: 'Probrat, co by se hodilo',
  canvasEmptyTitle: 'I trocha kontextu hodně pomůže.',
  canvasEmptyBody:
    'Výchozím bodem je profil vaší společnosti. Přidejte zdrojové materiály a zkontrolované poznámky, aby Poneva lépe rozuměla vaší práci.',
  pageEyebrow: 'Pracovní prostor {company}',
  pageTitle: 'Znalosti společnosti',
  pageDescription: 'Zdroje a porozumění, ze kterých Poneva při práci vychází.',
  tabOverview: 'Přehled',
  tabPages: 'Stránky',
  tabSources: 'Zdroje',
  tabReview: 'Ke kontrole',
  proposalApproved: 'Schválený kontext společnosti',
  proposalDismissed: 'Odmítnutý návrh',
  proposalRemoval: 'Navrhované odebrání',
  proposalCorrection: 'Navrhovaná oprava',
  proposalContext: 'Navrhovaný kontext společnosti',
  proposalCurrent: 'Současné porozumění',
  proposalFactGone:
    'Uložený fakt už není k dispozici. Než toto odebrání zkontrolujete, obnovte znalosti společnosti.',
  proposalReviewFallback: 'Zkontrolujte navrhovaný kontext společnosti.',
  proposalNotSaved: 'Zatím neuloženo. Původní zdroje zůstávají beze změny.',
  proposalWaiting: 'Čeká na kontrolu · rozhodne publikující ve své Doručené poště',
  proposalSaving: 'Ukládání…',
  proposalApproveRemoval: 'Schválit odebrání',
  proposalApproveClarification: 'Schválit upřesnění',
  factLabel: 'Fakt o společnosti',
  factEyebrow: 'Fakt · Všichni v rámci {company}',
  factSuggestCorrection: 'Navrhnout opravu',
  factAskPrompt: 'Pomoz mi pochopit nebo upřesnit tento uložený kontext společnosti: „{content}“',
  factAsk: 'Zeptat se na to',
  companyContextHeading: 'Kontext společnosti',
  companyContextPrompt:
    'Chci upřesnit znalosti naší společnosti. Pomoz mi zkontrolovat, co víme, a navrhnout úpravu.',
  companyContextEmpty:
    'Zatím žádné schválené poznámky. Začněte konverzaci o své společnosti nebo níže přidejte zdrojové materiály.',
  refineInChat: 'Vyladit v chatu',
  reviewPanelLabel: 'Změny znalostí ke kontrole',
  suggestedUpdatesHeading: 'Navrhované úpravy',
  suggestedUpdatesIntro:
    'Návrhy z vašich konverzací. Vy rozhodujete, co se stane trvalou součástí znalostí vaší společnosti.',
  reviewEmptyTitle: 'Nic nečeká na vaši kontrolu.',
  reviewEmptyBody:
    'Když Poneva navrhne změnu znalostí vaší společnosti, najdete ji tady. Trvalé změny vždy potřebují vaše schválení.',
  reviewEmptyPrompt:
    'Pomoz mi zkontrolovat znalosti naší společnosti a navrhni, co by bylo užitečné upřesnit dál.',
  inclusionPendingApproval: 'Změna zahrnutí do znalostí byla odeslána ke schválení.',
  sourcesFileIncluded: 'Soubor byl zahrnut do vyhledávání ve znalostech pro své aktuální publikum.',
  sourcesAddFailed: 'Tento zdroj se nepodařilo přidat.',
  sourcesHeading: 'Materiály, ze kterých odpovědi vycházejí.',
  sourcesIntro:
    'Poneva prohledává celé zdrojové materiály, nejen přehled. Uchovávejte originály, sledujte, co je připravené, a vybírejte, z čeho mají vaše odpovědi vycházet.',
  addSourceHeading: 'Přidejte materiály ze své společnosti',
  addSourceIntro:
    'Nahrané zdroje zůstávají soukromé ve vaší Knihovně a slouží jen vašim odpovědím. Až je budete chtít zpřístupnit kolegům, zvolte Sdílet.',
  uploadSource: 'Nahrát zdroj',
  addSourcePrompt:
    'Pomoz mi přidat prohlášení společnosti jako sdílený interní zdroj. Zeptej se, co chci zaznamenat, a nevymýšlej žádný obsah. Trvalé změny v porozumění společnosti stále potřebují moje schválení.',
  addThroughChat: 'Přidat přes chat',
  addingSource: 'Přidávání…',
  addToKnowledge: 'Přidat do znalostí',
  uploadFormats: 'TXT, Markdown, CSV a JSON · Až 5 MB na soubor',
  sourceExcluded: 'Vyloučeno z odpovědí',
  sourcePreparationFailed: 'Příprava selhala',
  sourcePreparing: 'Připravuje se pro vyhledávání',
  sourceWaiting: 'Čeká na přípravu',
  sourceReadinessUnknown: 'Stav připravenosti není k dispozici',
  sourceRetryQueued: 'Příprava je ve frontě. Stav připravenosti se aktualizuje po jejím dokončení.',
  sourceIncludedNotice: 'Zdroj byl zahrnut. Poneva ho připraví pro vyhledávání.',
  sourceExcludedNotice: 'Vyloučeno z odpovědí. Původní zdroj zůstává zachován.',
  sourceUpdateFailed: 'Tento zdroj se nepodařilo aktualizovat.',
  sourceOriginalMaterial: 'Původní zdrojový materiál',
  sourceDiscuss: 'Probrat v chatu',
  sourceDiscussPrompt: 'Pomoz mi pochopit nebo upřesnit „{title}“.',
  sourceExclude: 'Vyloučit z odpovědí',
  sourceInclude: 'Zahrnout do odpovědí',
  sourcesLoadFailed: 'Vaše zdroje se nepodařilo načíst.',
  sourceLibraryLabel: 'Knihovna zdrojů společnosti',
  sourceListCaption: 'Původní zdroje · zahrnuté i vyloučené',
  sourceSearchLabel: 'Hledat ve zdrojích společnosti',
  sourceSearchPlaceholder: 'Hledat ve zdrojích…',
  sourcesFinding: 'Hledání zdrojů…',
  sourcePagesLabel: 'Stránky zdrojů',
  sourceRange: '{from}–{to} · celkem {count}',
  sourceCount: 'one:zdroj|few:zdroje|many:zdroje|other:zdrojů',
  sourcePrevious: 'Předchozí',
  sourceNext: 'Další',
  sourceNoMatchTitle: 'Žádné odpovídající zdroje.',
  sourceNoMatchBody: 'Zkuste jiný výraz nebo název zdroje.',
  sourceEmptyTitle: 'Dejte svým otázkám pevnější základ.',
  sourceEmptyBody:
    'Přidejte dokumenty společnosti, produktová data nebo pracovní poznámky. Poneva může celé zdrojové materiály využít v konverzacích i ve Skillech.',
  indexCheckFailed: 'Nepodařilo se ověřit přípravu zdrojů.',
  indexRetryQueued:
    'Neúspěšné položky znalostí byly zařazeny do fronty k přípravě. Vaše zdrojové materiály se nemění.',
  indexQueueFailed: 'Přípravu se nepodařilo zařadit do fronty. Zkuste to znovu.',
  indexPreparing: 'Připravují se nové znalosti pro vaše konverzace…',
  indexAttention: 'Některé znalosti vyžadují pozornost.',
  queuing: 'Zařazování do fronty…',
  retryPreparation: 'Zopakovat přípravu',
  sourceKindStatement: 'Prohlášení společnosti',
  sourceKindWebsite: 'Web',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:odpověď|few:odpovědi|many:odpovědi|other:odpovědí',
  factUsedThisWeek: 'Použito tento týden: {answers}',
  factLastUsed: 'naposledy použito: {when}',
  factToday: 'dnes',
  factYesterday: 'včera',
  factImpact: 'Tato změna ovlivní fakt použitý tento týden ({answers}).',
  factCorrectionAbout: 'K tomuto faktu o společnosti: „{content}“ ({link})',
  factCorrectionOutdated: 'Toto už neplatí:',
  sourceCanvasRecorded: 'Zaznamenaný zdrojový materiál',
  sourceCanvasNotIncluded:
    'Není součástí znalostí společnosti. Originál zůstává uložen pro referenci a dá se dál použít v konkrétní konverzaci.',
  sourceCanvasOpenOriginal: 'Otevřít původní zdroj',
  sourceCanvasUnavailable: 'Obsah zdroje není k dispozici.',
  sourceCanvasDiscussPrompt: 'Pomoz mi pochopit nebo upřesnit „{title}“.',
  sourceCanvasDiscuss: 'Probrat tento zdroj',
  sourceCanvasCorrectionNote:
    'Oprava se stane navrhovaným kontextem společnosti. Zaznamenaný zdroj zůstane beze změny.',
  contextCanvasEyebrow: 'Dostupný kontext společnosti',
  contextCanvasTitle: 'Znalosti za touto konverzací.',
  contextCanvasBody:
    'Schválené porozumění a zdrojové materiály, které vaše společnost přidala. K dispozici v chatu a ve Skills.',
  contextCanvasOpen: 'Otevřít Znalosti',
};

export default cs;
